module.exports = __webpack_public_path__ + "img/chanquansousuo.7717e189.png";